import { SocketEvent } from '@/services/ws/core/event'

class VerificationStatus extends SocketEvent {
  async handle(data, { store }) {
    const { status } = data?.payload

    if (status === 'error') {
      // TODO: use when ready error document missing in diia
      // const documentType = 'internal-passport' // pass string document type/scope from backend
      // store.dispatch('diia/act_setMissingDiiaDocument', documentType)
    }
  }
}

export const verificationStatus = new VerificationStatus()
